import { useEffect } from "react";

export function useDragDropPrevention() {
    useEffect(() => {
        const handleDrop = (e: DragEvent) => {
            if (!(e.target as HTMLElement)?.closest(".drop-zone")) {
                e.preventDefault();
                e.stopPropagation();
            }
        };

        const handleDragOver = (e: DragEvent) => {
            if (!(e.target as HTMLElement)?.closest(".drop-zone")) {
                e.dataTransfer!.dropEffect = "none";
                e.preventDefault();
            }
        };

        window.addEventListener("drop", handleDrop);
        window.addEventListener("dragover", handleDragOver);

        return () => {
            window.removeEventListener("drop", handleDrop);
            window.removeEventListener("dragover", handleDragOver);
        };
    }, []);
}
